import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { toGetOrderRecords, toGetRoute, toReorder } from '@/api/correspondence/task/form';
import { mapState } from 'vuex';
export default {
  name: 'history-component',
  props: {
    inDialog: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    code: {
      type: String,
      default: function _default() {
        return undefined;
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      form: {
        code: undefined
      },
      rules: {},
      tableData: [],
      multipleSelection: [],
      orderMessage: {
        succeeded: [],
        failed: []
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('cpscc', ['userInfo'])), {}, {
    isHX: function isHX() {
      return this.$store.state.cpscc.isHX;
    },
    isAdmin: function isAdmin() {
      var user = this.userInfo;
      if (user && user.data2) {
        return user.data2.admin;
      }
      return false;
    },
    isCpscAdmin: function isCpscAdmin() {
      if (this.userInfo && this.userInfo.data2) {
        if (Array.isArray(this.userInfo.data2.roles)) {
          return this.userInfo.data2.roles.includes('函证中心管理员');
        }
      }
      return false;
    },
    isSender: function isSender() {
      if (this.userInfo && this.userInfo.data2) {
        if (Array.isArray(this.userInfo.data2.roles)) {
          return this.userInfo.data2.roles.includes('发函操作员');
        }
      }
      return false;
    }
  }),
  methods: {
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    selectable: function selectable(row) {
      return row.c61Status === '下单失败';
    },
    submit: function submit() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.loading = true;
              _this.tableData = [];
              _this.multipleSelection = [];
              _context.n = 1;
              return _this.$awaitTo(toGetOrderRecords({
                confirmcode: _this.form.code
              }));
            case 1:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 2);
              err = _yield$_this$$awaitTo2[0];
              data = _yield$_this$$awaitTo2[1];
              _this.loading = false;
              if (!err) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              if (Array.isArray(data)) {
                _this.tableData = data;
              }
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    reorder: function reorder() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(_this2.multipleSelection.length > 10)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, _this2.$message.warning('每次最多为10条'));
            case 1:
              _this2.loading = true;
              _context2.n = 2;
              return _this2.$awaitTo(toReorder(_this2.multipleSelection.map(function (item) {
                return item.c61Id;
              })));
            case 2:
              _yield$_this2$$awaitT = _context2.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 2);
              err = _yield$_this2$$awaitT2[0];
              data = _yield$_this2$$awaitT2[1];
              _this2.loading = false;
              if (!err) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              _this2.multipleSelection = [];
              _this2.$refs.table.clearSelection();
              _this2.orderMessage = data;
            case 4:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  },
  created: function created() {
    if (this.inDialog && this.code) {
      this.form.code = this.code;
      this.submit();
    }
  }
};